import React, { Component } from 'react';

import './ProductDataSelector.css'

class ProductDataSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lowerBound: 1,
            price: (typeof this.props.startPrice === 'undefined' ? 20 : this.props.startPrice.price),
            upperBound: 99
        };

        this.incrementPrice = this.incrementPrice.bind(this);
        this.decrementPrice = this.decrementPrice.bind(this);
    }

    incrementPrice() {
        let currentPrice = this.state.price;

        if (currentPrice === this.state.upperBound) {
            return;
        }

        this.setState({
            price: currentPrice += 1
        });

        this.props.setPrice(this.props.category.label, this.props.category.internalName, currentPrice);
    }

    decrementPrice() {
        let currentPrice = this.state.price;

        if (currentPrice === this.state.lowerBound) {
            return;
        }

        this.setState({
            price: currentPrice -= 1
        });

        // Change price in parent
        this.props.setPrice(this.props.category.label, this.props.category.internalName, currentPrice);
    }

    componentDidMount() {
        // Set the default
        // setPrice is only otherwise called if user clicks increment /decrement
        this.props.setPrice(this.props.category.label, this.props.category.internalName, this.state.price);
    }

    render() {
        return(
            <div className="category-size-selector">
                <hr />
                <div className="row">
                    <div className="header-selector-center">
                        <p className="selector-header">{this.props.category.label}</p>

                        <div className="price-selector">
                            <button className="price-button" onClick={this.decrementPrice}>-</button>
                            <span className="price-text">${this.state.price}</span>
                            <button className="price-button" onClick={this.incrementPrice}>+</button>
                        </div>
                    </div>
                </div>

                <div className="size-selector">
                    <div className={"size-icon" + (this.props.getSelectedClass(this.props.category.internalName, 'small'))}
                         onClick={() => this.props.addSizeToObject(this.props.category.internalName, 'small')}>
                        <span>S</span>
                    </div>
                    <div className={"size-icon" + (this.props.getSelectedClass(this.props.category.internalName, 'medium'))}
                         onClick={() => this.props.addSizeToObject(this.props.category.internalName, 'medium')}>
                        <span>M</span>
                    </div>

                    <div className={"size-icon" + (this.props.getSelectedClass(this.props.category.internalName, 'large'))}
                         onClick={() => this.props.addSizeToObject(this.props.category.internalName, 'large')}>
                        <span>L</span>
                    </div>

                    <div className={"size-icon" + (this.props.getSelectedClass(this.props.category.internalName, 'extra_large'))}
                         onClick={() => this.props.addSizeToObject(this.props.category.internalName, 'extra_large')}>
                        <span>XL</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductDataSelector;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/ProductDataStep/components/ProductDataSelector.js